// extracted by mini-css-extract-plugin
export var certificationRowHeader = "StrapiEnglishLevelsTable-module--certificationRowHeader--25b3f";
export var hasTextWeightBold = "StrapiEnglishLevelsTable-module--has-text-weight-bold--03ca7";
export var highlight = "StrapiEnglishLevelsTable-module--highlight--9fc12";
export var isUppercase = "StrapiEnglishLevelsTable-module--is-uppercase--63222";
export var levelName = "StrapiEnglishLevelsTable-module--levelName--be68f";
export var mobile = "StrapiEnglishLevelsTable-module--mobile--b241a";
export var prefix = "StrapiEnglishLevelsTable-module--prefix--da5d2";
export var root = "StrapiEnglishLevelsTable-module--root--bacf5";
export var table = "StrapiEnglishLevelsTable-module--table--a4deb";
export var tableHeader = "StrapiEnglishLevelsTable-module--tableHeader--6192e";